import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getHighlightInCorrectWord = (params) => {
	var url = ApiRouters.HIGHLIGHTINCORRECTWORD;
	return api.get(url, { params });
};

export const getHighlightInCorrectWordDetail = (id, params) => {
	var url = `${ApiRouters.HIGHLIGHTINCORRECTWORD}/${id}`;
	return api.get(url, { params });
};

export const createQuesHighlightInCorrectWord = (body) => {
	var url = ApiRouters.HIGHLIGHTINCORRECTWORD;
	return api.post(url, body);
};

export const updateHighlightInCorrectWordDetail = (body) => {
	var url = `${ApiRouters.HIGHLIGHTINCORRECTWORD}/${body.get('id')}`;
	return api.put(url, body);
};

export const deleteHighlightInCorrectWord = (id) => {
	var url = `${ApiRouters.HIGHLIGHTINCORRECTWORD}/${id}`;
	return api.delete(url);
};
